import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import { fetchNewsList, mediaUrl } from '../api/news';

const NewsListPage = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    let alive = true;
    fetchNewsList()
      .then((items) => {
        if (alive) setNews(items);
      })
      .catch((e) => {
        if (alive) setError(e.message || 'Erro ao carregar notícias.');
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="bg-white">
      <Header />

      <section
        className="relative mt-[80px] py-24 md:py-32 px-6"
        style={{
          background: 'linear-gradient(180deg, #0e0e0e 0%, #1c1c1c 100%)',
        }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <p
            className="text-[#C99A36] tracking-[0.4em] text-[12px] font-semibold mb-4"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            SETA NEWS
          </p>
          <h1
            className="text-white text-[42px] md:text-[56px] font-bold tracking-tight"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Todas as Matérias
          </h1>
          <div className="mx-auto mt-6 w-24 h-[3px] bg-[#C99A36]" />
          <p
            className="mt-8 text-white/80 text-[15px] md:text-[16px] leading-[1.7] max-w-2xl mx-auto"
            style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
          >
            Acompanhe as novidades, projetos e resultados da SETA ao longo dos seus 30 anos de atuação.
          </p>
        </div>
      </section>

      <section className="py-20 px-6 bg-[#f5f5f3]">
        <div className="max-w-[1300px] mx-auto">
          {loading && (
            <p className="text-center text-[#888]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Carregando…
            </p>
          )}
          {error && (
            <p className="text-center text-red-600" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {error}
            </p>
          )}
          {!loading && !error && news.length === 0 && (
            <p className="text-center text-[#888]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Nenhuma matéria publicada.
            </p>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {news.map((n) => (
              <Link
                key={n.id}
                to={`/news/${n.slug}`}
                className="group bg-white shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer block"
              >
                <div className="overflow-hidden h-[220px]">
                  <img
                    src={mediaUrl(n.image)}
                    alt={n.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                  />
                </div>
                <div className="p-6">
                  <h3
                    className="text-[#1a1a1a] font-bold text-[16px] tracking-wide mb-3 group-hover:text-[#C99A36] transition-colors"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {n.title}
                  </h3>
                  <p
                    className="text-[#555] text-[13px] leading-[1.7] mb-4 line-clamp-3"
                    style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                  >
                    {n.excerpt}
                  </p>
                  <div
                    className="flex items-center gap-4 text-[11px] text-[#888] tracking-wide"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    <span className="flex items-center gap-1">
                      <Calendar size={12} /> {n.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <Clock size={12} /> {n.readTime}
                    </span>
                  </div>
                  <div
                    className="mt-5 flex items-center gap-2 text-[#C99A36] text-[12px] font-semibold tracking-[0.2em] opacity-0 group-hover:opacity-100 transition-opacity"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    LER MAIS <ArrowRight size={14} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NewsListPage;
